const PLACEHOLDER = {
  productfilterbar: 'Suche nach Name, Artikelnummer ...',
  systemfilterbar: 'Suche nach Name, Artikelnummer ...',
  select_attributes: 'Attribute auswählen ...',
  select_groups: 'Gruppe auswählen ...',
  select_delivery_address: 'Bitte Lieferadresse wählen ...',
  contact_at_location: 'Kontakt vor Ort',
  project: 'Bauvorhaben',
  select_language: 'Bitte Sprache wählen',
  enter_new_password: 'Neues Passwort ...',
  confirm_new_password: 'Neues Passwort bestätigen ...',
  phone: 'Telefonnummer',
  search_ral: 'RAL Farben suchen ...',
};

export default PLACEHOLDER;
